var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTalkingPoints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6638_9950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99996 0.833303C4.70746 0.833303 0.416626 4.37747 0.416626 8.74997C0.438854 9.83858 0.704932 10.9083 1.19528 11.8805C1.68562 12.8527 2.38774 13.7025 3.24996 14.3675L1.24996 19.1666L6.55996 16.1325C7.6723 16.4865 8.83263 16.6667 9.99996 16.6666C15.2925 16.6666 19.5833 13.1225 19.5833 8.74997C19.5833 4.37747 15.2925 0.833303 9.99996 0.833303Z",
    stroke: "#0C5CEF",
    strokeWidth: 0.73,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6638_9950"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalkingPoints);
export default __webpack_public_path__ + "static/media/talkingPoints.b3bc4272b3d9005b465f4931f5f1e19f.svg";
export { ForwardRef as ReactComponent };